var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "box" }, [
    _c("h1", { staticClass: "title is-5" }, [_vm._v("Estados")]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _vm.serieDocumental.estados.length == 0
      ? _c("p", { staticClass: "is-italic is-mono" }, [
          _vm._v("La serie no tiene estados"),
        ])
      : _c(
          "div",
          { staticClass: "field is-grouped is-grouped-multiline" },
          _vm._l(_vm.serieDocumental.estados, function (estado, slug) {
            return _c(
              "div",
              { key: `estado-${slug}`, staticClass: "control" },
              [
                _c("div", { staticClass: "tags has-addons" }, [
                  _c("div", { staticClass: "tag is-info is-medium" }, [
                    _vm._v(_vm._s(estado)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tag is-light is-medium" }, [
                    _c(
                      "a",
                      {
                        staticClass: "has-text-primary",
                        on: {
                          click: function ($event) {
                            return _vm.openPromptNuevoNombre(estado, slug)
                          },
                        },
                      },
                      [_c("i", { staticClass: "fas fa-edit" })]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tag is-light is-medium" }, [
                    _c(
                      "a",
                      {
                        staticClass: "has-text-primary",
                        on: {
                          click: function ($event) {
                            return _vm.openDialogDeleteEstado(estado, slug)
                          },
                        },
                      },
                      [_c("i", { staticClass: "fas fa-times-circle" })]
                    ),
                  ]),
                ]),
              ]
            )
          }),
          0
        ),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("h1", { staticClass: "subtitle is-5" }, [
      _vm._v("Crear un nuevo estado"),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "field" }, [
      _c("div", { staticClass: "field is-grouped" }, [
        _c("div", { staticClass: "control is-expanded" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.input.estado.nombre,
                expression: "input.estado.nombre",
              },
              {
                name: "validate",
                rawName: "v-validate",
                value: { required: true },
                expression: "{required: true}",
              },
            ],
            staticClass: "input",
            class: {
              "is-danger": _vm.errors.has("Nombre del estado", "estado"),
            },
            attrs: {
              name: "Nombre del estado",
              "data-vv-scope": "estado",
              placeholder: "Ingrese el nombre de un estado",
            },
            domProps: { value: _vm.input.estado.nombre },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.input.estado, "nombre", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "help" }, [_vm._v("Nombre del estado")]),
          _vm._v(" "),
          _vm.errors.has("Nombre del estado", "estado")
            ? _c("span", { staticClass: "help is-danger" }, [
                _vm._v(_vm._s(_vm.errors.first("Nombre del estado", "estado"))),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "control is-expanded" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.input.estado.slug,
                expression: "input.estado.slug",
              },
              {
                name: "validate",
                rawName: "v-validate",
                value: {
                  required: true,
                  regex: /^[a-z0-9]+(?:[-_+][a-z0-9]+)*$/,
                },
                expression:
                  "{required: true, regex: /^[a-z0-9]+(?:[-_+][a-z0-9]+)*$/ }",
              },
            ],
            staticClass: "input is-mono",
            class: {
              "is-danger": _vm.errors.has("Clave del estado", "estado"),
            },
            attrs: { name: "Clave del estado", "data-vv-scope": "estado" },
            domProps: { value: _vm.input.estado.slug },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.input.estado, "slug", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "help" }, [
            _vm._v(
              "La clave del estado es autogenerado pero pude editarlo de preferirlo"
            ),
          ]),
          _vm._v(" "),
          _vm.errors.has("Clave del estado", "estado")
            ? _c("span", { staticClass: "help is-danger" }, [
                _vm._v(_vm._s(_vm.errors.first("Clave del estado", "estado"))),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "control", on: { click: _vm.submitEstado } }, [
          _vm._m(1),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("h1", { staticClass: "subtitle is-5" }, [
      _vm._v("Estado inicial de la serie"),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "field is-grouped" }, [
      _c("div", { staticClass: "control is-expanded" }, [
        _c("div", { staticClass: "select is-fullwidth" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectedSlugEstadoInicial,
                  expression: "selectedSlugEstadoInicial",
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: true },
                  expression: "{required:true}",
                },
              ],
              class: { "is-danger": _vm.errors.has("Estado inicial", "serie") },
              attrs: { name: "Estado inicial", "data-vv-scope": "serie" },
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.selectedSlugEstadoInicial = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
              },
            },
            [
              _c(
                "option",
                { attrs: { disabled: "" }, domProps: { value: null } },
                [_vm._v("- Seleccione un estado inicial -")]
              ),
              _vm._v(" "),
              _vm._l(_vm.serieDocumental.estados, function (estado, slug) {
                return _c(
                  "option",
                  { key: `estado-inicial-${slug}`, domProps: { value: slug } },
                  [_vm._v(_vm._s(estado))]
                )
              }),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "control" }, [
        _c(
          "button",
          { staticClass: "button is-primary", on: { click: _vm.submit } },
          [
            _c("i", { staticClass: "fas fa-save fa-fw" }),
            _vm._v(" Guardar\n       "),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.errors.has("Estado inicial", "serie")
      ? _c("span", { staticClass: "help is-danger" }, [
          _vm._v(_vm._s(_vm.errors.first("Estado inicial", "serie"))),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content" }, [
      _c("p", [
        _vm._v("Puede cambiar el nombre de un estado haciendo clic en "),
        _c("i", { staticClass: "fas fa-edit has-text-primary" }),
        _vm._v(", o eliminar haciendo clic en el botón "),
        _c("i", { staticClass: "fas fa-times-circle has-text-primary" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("button", { staticClass: "button is-primary" }, [
      _c("i", { staticClass: "fas fa-plus" }),
      _vm._v(" Agregar\n         "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }